import type { AmbleContent } from "../..";
import { harborwayTermsOfPolicy } from "../../shared/terms-of-policy";
import { wholesalerContactInfoAgentEmailCopy } from "../../shared/wholesaler-contact-info";

const getAffordableQuotes =
  "<p>Thank you for using Simply Business to get a quote for your small business client.</p><p>Your agent details, including your email address, have been provided by Wholesure to Simply Business and will be linked by Simply Business to every quote and policy you create. By starting a quote with Simply Business you consent to receive emails from Simply Business regarding incentives, promotions, product updates and other exciting news. You can unsubscribe at any time.</p>";

export const ambles: Record<string, AmbleContent> = {
  usa_business_get_affordable_quotes: getAffordableQuotes,
  usa_wholesaler_contact_information: wholesalerContactInfoAgentEmailCopy,
  terms_of_policy: harborwayTermsOfPolicy,
};
